import React, { useState } from 'react';
import { CheckCircleIcon, XCircleIcon, EyeIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
import Modal from '../../components/ui/Modal';
const CashbackApproval: React.FC = () => {
  // Mock pending campaigns
  const [pendingCampaigns, setPendingCampaigns] = useState([{
    id: 'CB-2023-002',
    name: 'Digital Week Bonanza',
    code: 'DIGI-WK-23',
    maker: 'admin@paysys.com',
    submittedAt: '2023-09-28 14:30',
    budget: 1000000,
    status: 'pending'
  }, {
    id: 'CB-2023-005',
    name: 'Flash Sale Cashback',
    code: 'FLASH-23',
    maker: 'manager@paysys.com',
    submittedAt: '2023-09-29 09:15',
    budget: 500000,
    status: 'pending'
  }]);
  const [selectedCampaign, setSelectedCampaign] = useState<any>(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const handleApprove = () => {
    setPendingCampaigns(prev => prev.filter(c => c.id !== selectedCampaign.id));
    setShowApproveModal(false);
    setSelectedCampaign(null);
  };
  const handleReject = () => {
    setPendingCampaigns(prev => prev.filter(c => c.id !== selectedCampaign.id));
    setShowRejectModal(false);
    setRejectReason('');
    setSelectedCampaign(null);
  };
  const columns = [{
    header: 'Campaign Name',
    accessor: 'name'
  }, {
    header: 'Code',
    accessor: 'code'
  }, {
    header: 'Maker',
    accessor: 'maker'
  }, {
    header: 'Submitted At',
    accessor: 'submittedAt'
  }, {
    header: 'Budget',
    accessor: (row: any) => `PKR ${row.budget.toLocaleString()}`
  }, {
    header: 'Status',
    accessor: () => <StatusBadge status="warning" text="Pending Approval" data-id="element-3152" />
  }];
  return <div className="space-y-6" data-id="element-3153">
      <div data-id="element-3154">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-3155">
          Pending Approvals
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-3156">
          Review and approve cashback campaigns submitted by makers
        </p>
      </div>

      <Card data-id="element-3157">
        <Table columns={columns} data={pendingCampaigns} keyField="id" actions={row => <div className="flex justify-end space-x-2" data-id="element-3159">
              <button className="p-1 text-gray-500 hover:bg-gray-100 rounded-full" title="View Details" data-id="element-3160">
                <EyeIcon className="h-5 w-5" data-id="element-3161" />
              </button>
              <button onClick={() => {
          setSelectedCampaign(row);
          setShowApproveModal(true);
        }} className="p-1 text-green-600 hover:bg-green-100 rounded-full" title="Approve" data-id="element-3162">
                <CheckCircleIcon className="h-5 w-5" data-id="element-3163" />
              </button>
              <button onClick={() => {
          setSelectedCampaign(row);
          setShowRejectModal(true);
        }} className="p-1 text-red-600 hover:bg-red-100 rounded-full" title="Reject" data-id="element-3164">
                <XCircleIcon className="h-5 w-5" data-id="element-3165" />
              </button>
            </div>} data-id="element-3158" />
      </Card>

      <Modal isOpen={showApproveModal} onClose={() => setShowApproveModal(false)} title="Confirm Approval" data-id="element-3166">
        <div className="space-y-4" data-id="element-3167">
          <p data-id="element-3168">
            Are you sure you want to approve{' '}
            <strong data-id="element-3169">{selectedCampaign?.name}</strong>?
          </p>
          <div className="flex justify-end space-x-3" data-id="element-3170">
            <button onClick={() => setShowApproveModal(false)} className="px-4 py-2 border rounded-md" data-id="element-3171">
              Cancel
            </button>
            <button onClick={handleApprove} className="px-4 py-2 bg-green-600 text-white rounded-md" data-id="element-3172">
              Approve
            </button>
          </div>
        </div>
      </Modal>

      <Modal isOpen={showRejectModal} onClose={() => setShowRejectModal(false)} title="Reject Campaign" data-id="element-3173">
        <div className="space-y-4" data-id="element-3174">
          <p data-id="element-3175">Please provide a reason for rejection:</p>
          <textarea className="w-full border rounded-md p-2" rows={3} value={rejectReason} onChange={e => setRejectReason(e.target.value)} data-id="element-3176" />
          <div className="flex justify-end space-x-3" data-id="element-3177">
            <button onClick={() => setShowRejectModal(false)} className="px-4 py-2 border rounded-md" data-id="element-3178">
              Cancel
            </button>
            <button onClick={handleReject} disabled={!rejectReason} className="px-4 py-2 bg-red-600 text-white rounded-md disabled:opacity-50" data-id="element-3179">
              Reject
            </button>
          </div>
        </div>
      </Modal>
    </div>;
};
export default CashbackApproval;